import clsx from "clsx";
import React, { useMemo } from "react";
import LTSBetButton from "src/components/bet-button/lts-bet-button";
import { MarketEventI, MarketRunnerI } from "src/types/eventDetail";
import { getIsBallRunning, getIsSuspended } from "src/utils/functions";

interface SixColTableRowProps {
  runner: MarketRunnerI;
  event: any;
  market: MarketEventI;
  exposuresByApi: any;
  maxAmount?: number;
}

const MarketTableRow: React.FC<SixColTableRowProps> = ({ runner, event, market, exposuresByApi }) => {
  const isSuspended = getIsSuspended({ providerStatus: runner?.provider_status, marketStatus: market.provider_status });
  const isBallRunning = getIsBallRunning({
    providerStatus: runner?.provider_status,
    marketStatus: market.provider_status,
  });

  const runnerExposure = useMemo(() => {
    return exposuresByApi?.runners?.find((run: { runner_id: any }) => runner?.runner_id === run?.runner_id);
  }, [exposuresByApi, runner?.runner_id]);

  const r1 = event?.runners?.[0];
  const r2 = event?.runners?.[1];
  const r3 = event?.runners?.[2];

  const r1Suspended = getIsSuspended({ providerStatus: r1?.provider_status });
  const r2Suspended = getIsSuspended({ providerStatus: r2?.provider_status });
  const r3Suspended = getIsSuspended({ providerStatus: r3?.provider_status });

  const back1 = runner.back?.[0];
  const back2 = runner.back?.[1];
  const back3 = runner.back?.[2];

  const lay1 = runner.lay?.[0];
  const lay2 = runner.lay?.[1];
  const lay3 = runner.lay?.[2];

  return (
    <div
      data-title={runner?.provider_status.split("_").join(" ")}
      className={clsx("bet-table-row", {
        suspendedfull: isBallRunning || isSuspended,
      })}
    >
      <div className="nation-name d-none-mobile">
        <p>{runner.runner_name}</p>
        <p
          className="mb-0 float-left"
          style={{ color: runnerExposure?.profit <= 0 || !runnerExposure?.profit ? "red" : "green" }}
        >
          {runnerExposure?.profit || "0"}
        </p>
        <p className="mb-0 float-right d-none">0</p>
      </div>
      <LTSBetButton
        type="back"
        index="3"
        odds={back3?.price}
        size={back3?.size}
        runner={runner}
        currentMarket={market as any}
        event={event as any}
        curMarketExposure={exposuresByApi}
      />
      <LTSBetButton
        type="back"
        index="2"
        odds={back2?.price}
        size={back2?.size}
        runner={runner}
        currentMarket={market as any}
        event={event as any}
        curMarketExposure={exposuresByApi}
      />
      <LTSBetButton
        type="back"
        index="1"
        odds={back1?.price}
        size={back1?.size}
        runner={runner}
        currentMarket={market as any}
        event={event as any}
        curMarketExposure={exposuresByApi}
      />

      <LTSBetButton
        type="lay"
        index="1"
        odds={lay1?.price}
        size={lay1?.size}
        runner={runner}
        currentMarket={market as any}
        event={event as any}
        curMarketExposure={exposuresByApi}
      />
      <LTSBetButton
        type="lay"
        index="2"
        odds={lay2?.price}
        size={lay2?.size}
        runner={runner}
        currentMarket={market as any}
        event={event as any}
        curMarketExposure={exposuresByApi}
      />
      <LTSBetButton
        type="lay"
        index="3"
        odds={lay3?.price}
        size={lay3?.size}
        runner={runner}
        currentMarket={market as any}
        event={event as any}
        curMarketExposure={exposuresByApi}
      />
      {/* <div className="bl-box back back2">
        <span className="d-block odds">1.62</span> <span className="d-block">1.78</span>
      </div>
      <div className="bl-box back back1">
        <span className="d-block odds">1.73</span> <span className="d-block">6.46</span>
      </div>
      <div className="bl-box back back">
        <span className="d-block odds">1.84</span> <span className="d-block">2.71</span>
      </div>
      <div className="bl-box lay lay">
        <span className="d-block odds">1.96</span> <span className="d-block">2</span>
      </div>
      <div className="bl-box lay lay1">
        <span className="d-block odds">2.26</span> <span className="d-block">317.28</span>
      </div>
      <div className="bl-box lay lay2">
        <span className="d-block odds">2.98</span> <span className="d-block">34.48</span>
      </div> */}
    </div>
  );
};

export default MarketTableRow;
